import { GeoLocationStatus } from '../../../../stores/GlobalStateStore';
import type { UseLocationContextReturn } from '../type';

function getGeoLocation(): Promise<UseLocationContextReturn['geoLocation'] | null> {
  if (!('geolocation' in navigator)) {
    console.error('Geolocation is not supported by this browser.');
    throw new Error('Geolocation is not supported by this browser.');
  }

  return new Promise((resolve) => {
    navigator.geolocation.getCurrentPosition(
      (position) => {
        resolve({
          isMocked: false,
          status: GeoLocationStatus.Granted,
          coordinates: {
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
          },
        });
      },
      (positionError) => {
        switch (positionError.code) {
          case positionError.TIMEOUT:
          case positionError.POSITION_UNAVAILABLE:
            resolve({
              isMocked: false,
              status: GeoLocationStatus.Disabled,
            });
            break;
          case positionError.PERMISSION_DENIED:
            resolve({
              isMocked: false,
              status: GeoLocationStatus.UserDenied,
            });
            break;
          default:
            resolve(null);
        }
      },
    );
  });
}

export default getGeoLocation;
